'use strict';

var t="SPAN",n="INPUT";

exports.a = t;
exports.b = n;
